import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useState, useEffect, useRef } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import CircularProgress from '@mui/material/CircularProgress';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const AppSwitcher = (props) => {

    const routes = useRecoilValue(atoms.routes);
    const [isLoading, setIsLoading] = useState(true);
    const [apps, setApps] = useState([]);
    const [error, setError] = useState(null);
    const modalRef = useRef(null);
    const itemRef = useRef(null);
    const windowSize = useWindowSize();

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('touchmove', handleScroll);
        document.addEventListener('mousedown', handleClick);
        sandhillsRequest({
            url: routes.GetAppSwitcherApps,
            method: 'GET',
            errorHandling: {
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setApps(response);
                setIsLoading(false);
                if (windowSize.isMobile) {
                    itemRef.current.focus(); // Reset scroll position for mobile view
                }
            } else {
                setIsLoading(false);
                setError('Failed to load apps. Please Try Again Later');
            }
        });
    }, []);
    const handleScroll = () => {
        const scrollPosition = window.scrollY;

        if (scrollPosition > 100) {
            props.onClose();
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
            document.removeEventListener('mousedown', handleClick);
        }
    }

    const handleClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target) && !(event.target.className.includes("app-switcher-link") || event.target.className.includes("fas"))) {
            event.preventDefault();
            props.onClose();
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
            document.removeEventListener('mousedown', handleClick);
        }
    };


    return (
        <div className='app-switcher' ref={modalRef}>
            {isLoading &&
                <span sx={{ width: '200px', height: '200px', textAlign: 'center', alignItems: 'center' }}>
                    <CircularProgress sx={{ height: '75px', width: '75px' }} /></span>}
            {error && <div className='error'>{error}</div>}
            {apps?.length > 0 &&
                apps.map((app, index) => {
                    return (
                        <a className='app-item' ref={index == 0 ? itemRef : null} key={app.SortOrder} href={app.TargetURL} target="_blank">
                            <img src={app.MediaURL} alt={app.DisplayName} />
                            <span>{app.DisplayName}</span>
                        </a>
                    )
                })
            }
        </div>
    );
};

export default AppSwitcher;
